import { getSubdomain } from './getSubdomain';

export type ScoreColor = 'green' | 'orange' | 'red' | 'gray';

export interface ScoreThreshold {
  /** Pontuação mínima (>=) para aplicar a cor. */
  min: number;
  color: ScoreColor;
}

/** Faixas padrão — comportamento atual do sistema. */
export const DEFAULT_SCORE_THRESHOLDS: ScoreThreshold[] = [
  { min: 80, color: 'green' },
  { min: 50, color: 'orange' },
  { min: 25, color: 'red' },
  { min: 0, color: 'gray' },
];

/**
 * Faixas específicas por subdomain (chaves em minúsculas).
 * Adicione aqui novos workspaces que precisem de thresholds diferentes.
 */
export const SCORE_THRESHOLDS_BY_WORKSPACE: Record<string, ScoreThreshold[]> =
  {
    sesrj: [
      { min: 100, color: 'green' }, // verde apenas quando pontuação é 100%
      { min: 50, color: 'orange' },
      { min: 25, color: 'red' },
      { min: 0, color: 'gray' },
    ],
  };

/**
 * Retorna as faixas de cor configuradas para o subdomain informado.
 * Se não houver configuração específica, retorna DEFAULT_SCORE_THRESHOLDS.
 */
export const getScoreThresholds = (
  subdomain: string = getSubdomain(),
): ScoreThreshold[] =>
  SCORE_THRESHOLDS_BY_WORKSPACE[subdomain?.toLowerCase()] ??
  DEFAULT_SCORE_THRESHOLDS;

/**
 * Retorna a cor (colorScheme do Chakra) correspondente à pontuação percentual.
 * As faixas são resolvidas pelo subdomain atual (ou pelo subdomain informado,
 * útil para testes).
 */
export const getScoreColor = (
  score: number,
  subdomain: string = getSubdomain(),
): ScoreColor => {
  const thresholds = getScoreThresholds(subdomain);
  const match = thresholds.find((t) => score >= t.min);
  return match?.color ?? 'gray';
};
